import searchUrl from "./url";
import SearchActivity from "./activity/";
import SearchLocationController from "./location/controller";
import SearchPeriods from "./periods/module";
import SearchPeriodsFixed from "./periods-fixed/module";
import SearchFactory from "./factory";
import SearchResultFactory from "./factory-results";
import SearchService from "./service";

const modul = angular
    .module("searchControllers", [
        SearchActivity,
        SearchPeriods,
        SearchPeriodsFixed,
    ])
    .controller("SearchLocationController", SearchLocationController)
    .service("searchService", SearchService)
    .factory("searchFactory", SearchFactory)
    .factory("searchResultFactory", SearchResultFactory)
    .factory("searchUrl", searchUrl);

export default modul.name;
